import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-126" data-mp="124g9kc8reoqi">
      <div id="faq-title" data-id="element-127" data-mp="1pszfwm890rfy">
        <SectionHeading title={<>
              Frequently asked <em className="italic text-brand-600" data-id="element-129" data-mp="1utddtbg4yl09">questions</em>
            </>} data-id="element-128" data-mp="1uraq4y2gh3yp" />
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-130" data-mp="1g0jxjnt1i0uj">
        {faqs.map((faq, i) => {
        const isOpen = open === i;
        return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-brand-100" data-id="element-131" data-mp="28q0lo99mmvky" data-mpi={i}>
              <h3 data-id="element-132" data-mp="2dik2df3m26tz">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-[17px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500" data-id="element-133" data-mp="2dj37twc2r2r4">
                  {faq.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-134" data-mp="37foy7q4rixzi" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-135" data-mp="3cg2y2kw7n1mg">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-136" data-mp="1n0vcpsfy65mj">
                    <p className="px-5 pb-5 text-[17px] leading-relaxed text-ink/75" data-id="element-137" data-mp="2bqrbw13dgyma">{faq.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <TransformCta label="Yes! I want Reflexology 360°" data-id="element-138" data-mp="2lra1lchmb9c4" />
    </section>;
}